var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsajHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24 40.1 14.2-8.1v-16.6l-1.8969-1.0687-12.3031 6.8735-10.0051-5.643 12.1708-6.94165-.595-.33525c-.9751-.54934-2.1663-.54934-3.1414 0l-12.62931 7.1151v1.3l14.20001 8.2 12-6.9296v12.7518l-12 6.845-11.4955-6.5572c-.3119-.178-.5045-.5095-.5045-.8687v-6.6958l9.2404 5.2311c.0867.0491.1664.1073.2381.173.0984.0902.1818.1946.2478.3091.031.0538.0581.1098.0812.1676.0602.1509.0925.3139.0925.4816v.2289c0 .3842-.4155.6249-.7488.4337l-5.7012-3.2705v.805c0 .4195.0821.8273.235 1.2038.2633.6483.7365 1.2037 1.3617 1.5656l5.3021 3.0697c.7334.4245 1.6512-.1046 1.6512-.952v-3.7334c0-.9645-.5145-1.8558-1.3498-2.3382l-10.7501-6.2078c-.3704-.2139-.7776-.2368-1.134-.1192-.5417.1786-.96611.6816-.96611 1.3316v8.3162c0 1.1493.61621 2.2102 1.61441 2.7796z",
    fill: "#e60012",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsajHome);
export default __webpack_public_path__ + "static/media/esaj-home.b22f9e84504e3206b6b15543e2204b54.svg";
export { ForwardRef as ReactComponent };